import UpdateSupplierModal from './UpdateSupplierModal';
export default UpdateSupplierModal;
